<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table tx-12">
        <thead>
          <tr>
            <th class="wd-50">
              <label class="mg-b-0 ckbox">
                <input
                  type="checkbox"
                  :checked="allCheck"
                  @change="allCheckChange($event)"
                />
                <span></span>
              </label>
            </th>
            <th>{{ $t("financial.标题") }}</th>
            <th>{{ $t("financial.经销商信息") }}</th>
            <th>{{ $t("financial.同步时间") }}</th>
            <th>{{ $t("financial.状态") }}</th>
            <th>{{ $t("financial.操作") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td class="valign-middle">
              <label class="mg-b-0 ckbox">
                <input type="checkbox" :value="item.id" v-model="checkArr" />
                <span></span>
              </label>
            </td>
            <td class="valign-middle">
              <div class="d-inline-block tx-white one-line-ellipsis" style="max-width: 150px">
                {{ item.title }}
              </div>
            </td>
            <td class="valign-middle">
              <div class="d-inline-block tx-white" style="max-width: 200px">
                {{ item.distributorName }}
              </div>
            </td>
            <td class="valign-middle">
              {{ item.sendDate ? timeFormat(item.sendDate) : "---" }}
            </td>
            <td class="valign-middle">
              {{ statusList[item.status] }}
            </td>
            <td class="valign-middle">
              <a
                class="tx-info"
                href="javascript:;"
                @click="openDetail(item)"
                >{{ $t("dashboard.查看详情") }}</a
              >
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="7">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i
                >{{ $t("financial.没有符合条件的KPI数据") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["items", "first_loading", "check_arr"],
  data() {
    return {
      checkArr: [],
      statusList: {
        1: this.$t("financial.未同步"),
        2: this.$t("financial.已同步"),
        3: this.$t("financial.已废弃"),
        4: this.$t("financial.已查看"),
      },
      userInfo: store.get("userInfo"),
    };
  },
  computed: {
    allCheck() {
      return this.items.length && this.checkArr.length == this.items.length;
    },
  },
  watch: {
    check_arr() {
      this.checkArr = this.check_arr;
    },
    checkArr() {
      this.$parent.checkArr = this.checkArr;
    },
  },
  methods: {
    timeFormat(val) {
      return moment(val, "YYYY-MM-DD h:mm:ss").format("YYYY-MM-DD");
    },
    allCheckChange(e) {
      //全选 全不选
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach((item) => {
          this.checkArr.push(item.id);
        });
      }
    },
    openDetail(item) {
      if(userInfo.productStyle == 2){
        $.api_call(
        "api.SupplierKpi.viewKpi",
        {
          id: item.id
        },
        (r) => {
          if (r.ErrorCode == "9999") {
            this.$set(item, 'status', 4)
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
      } 
      this.$emit("openDetail", item);
    },
  },
};
</script>

<style lang='less' scoped>
.one-line-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* 非必须，只是为了制造一行放不下的效果 */
  max-width: 150px;
}
</style>
